module.exports = __webpack_public_path__ + "img/NoImg.a82b2164.png";